import { Map as ImmutableMap, fromJS } from 'immutable';
import UserProfile from '../records/UserProfile';
import { FetchProfileActionTypes, FetchIsScimUserActionTypes, UpdateProfileActionTypes, UpdateBlankProfileActionTypes } from '../actions/ProfileActions';
import { AddEmailActionTypes, DeleteEmailActionTypes, EditEmailAddressActionTypes, CancelPendingEmailAddressActionTypes, SetPrimaryActionTypes } from '../actions/EmailAddressActions';
import { handleActions } from 'flux-actions';
const initialState = new UserProfile();
export default handleActions({
  [FetchProfileActionTypes.SUCCESS](state, action) {
    const pendingEmailAddress = fromJS(action.payload.data.pendingEmailAddress);
    return state.merge(new UserProfile(Object.assign({}, action.payload.data, {
      pendingEmailAddress
    })));
  },
  [FetchIsScimUserActionTypes.SUCCESS](state, action) {
    return state.set('scim', action.payload.data);
  },
  [UpdateProfileActionTypes.SUCCESS](state, action) {
    return state.merge(new UserProfile(action.payload.props));
  },
  [UpdateBlankProfileActionTypes.SUCCESS](state, action) {
    return state.merge(new UserProfile(action.payload.props));
  },
  [EditEmailAddressActionTypes.SUCCESS](state, action) {
    return state.set('pendingEmailAddress', ImmutableMap({
      email: action.payload.props
    }));
  },
  [CancelPendingEmailAddressActionTypes.SUCCESS](state) {
    return state.set('pendingEmailAddress', undefined);
  },
  [AddEmailActionTypes.SUCCESS](state, action) {
    const loginEmails = [...state.get('loginEmails')];
    loginEmails.push(action.payload.data);
    return state.set('loginEmails', loginEmails);
  },
  [DeleteEmailActionTypes.SUCCESS](state, action) {
    const loginEmails = state.get('loginEmails').filter(email => email.id !== action.payload.props);
    return state.set('loginEmails', loginEmails);
  },
  [SetPrimaryActionTypes.SUCCESS](state, action) {
    const loginEmails = state.get('loginEmails').map(email => Object.assign({}, email, {
      primary: action.payload.props === email.id
    }));
    return state.set('loginEmails', loginEmails);
  }
}, initialState);